__turbopack_context__.v({
  "raceTeamPlayButton": "RaceTeamVideo-module-scss-module__ZSlonW__raceTeamPlayButton",
  "raceTeamVideo": "RaceTeamVideo-module-scss-module__ZSlonW__raceTeamVideo",
  "raceTeamVideoImage": "RaceTeamVideo-module-scss-module__ZSlonW__raceTeamVideoImage",
});
